import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog'


@Component({
    selector: 'app-modal',
    templateUrl: './modal.component.html',
    styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
    @Input() dismissible = true;
    @Input() isLoading = false;
    @Input() autoZIndex = false;
    @Input() baseZIndex = 999;

    @Output() show = new EventEmitter<any>();
    @Output() dismiss = new EventEmitter<any>();

    _isOpen = false;

    constructor(public dialogService: DialogService) {
    }

    // Opens the modal
    open() {
        this._isOpen = true;
    }

    // Closes the modal
    close() {
        this._isOpen = false;
    }

    // Post-Open callback
    onShow() {
        this.show.emit()
    }

    // Post-Close callback
    onDismiss() {
        this.dismiss.emit();
    }

    isOpen() {
        return this._isOpen;
    }
}
